import { render, staticRenderFns } from "./AlbumGallery.vue?vue&type=template&id=a6e736e2&scoped=true"
import script from "./AlbumGallery.vue?vue&type=script&lang=js"
export * from "./AlbumGallery.vue?vue&type=script&lang=js"
import style0 from "./AlbumGallery.vue?vue&type=style&index=0&id=a6e736e2&prod&lang=scss&scoped=true"
import style1 from "./AlbumGallery.vue?vue&type=style&index=1&id=a6e736e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e736e2",
  null
  
)

export default component.exports